module.exports = __webpack_public_path__ + "media/images/screenshot_chat-33b1a11d80b30e37105dfd3920bd1006.png";